import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FooterComponent } from './footer/footer.component';
import { RouterModule } from '@angular/router';
import { NavUserComponent } from './nav-user/nav-user.component';
import * as feather from 'feather-icons';
import { MatIconModule } from '@angular/material/icon';
import { BackButtonComponent } from './back-button/back-button.component';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ModalComponent } from './modal/modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DivisaCardComponent } from './divisa-card/divisa-card.component';
import { DivisaListComponent } from './divisa-list/divisa-list.component';
import { ReservacionCardComponent } from './reservacion-card/reservacion-card.component';
import { ReservacionTableComponent } from './reservas-table/reservas-table.component';
import { QRCodeModule } from 'angularx-qrcode';
import { ReservacionComponent } from './reservacion/reservacion.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ReservacionCompleteComponent } from './reservacion-complete/reservacion-complete.component';
import { ReservacionHistorialComponent } from './reservacion-historial/reservacion-historial.component';
import { ReservacionVencidaComponent } from './reservacion-vencida/reservacion-vencida.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxCurrencyDirective } from 'ngx-currency';
import { MatMenuModule } from '@angular/material/menu';
import { HistoricoBranchComponent } from './historico-branch/historico-branch.component';
import { SucursalCardComponent } from './sucursal-card/sucursal-card.component';
import { PromocionModalComponent } from './promo-modal/promo-modal.component';
import { PromotionDetailModalComponent } from './promotion-detail-modal/promotion-detail-modal.component';
import { PromoBranchPanelComponent } from './promotion-detail-modal/promo-branch-panel/promo-branch-panel.component';
import { SafeHtmlPipe } from '../pipes/safe-html.pipe';
import { MxnCurrencyPipe } from '../pipes/mxn-currency.pipe';
import { CentenarioUnitsPipe } from '../pipes/centenario-units.pipe';
import { CurrencyNamePipe } from '../pipes/currency-name.pipe';
import { SucursalCardPromoComponent } from './sucursal-card-promo/sucursal-card-promo.component';
import { QuoterComponent } from '../components/quoter/quoter.component';
import { PickupScheduleComponent } from '../components/pickup-schedule/pickup-schedule.component';
import { BranchSelectorComponent } from '../components/branch-selector/branch-selector.component';
import { ReservationConfirmationComponent } from '../components/reservation-confirmation/reservation-confirmation.component';
import { LoginPromptComponent } from '../components/login-prompt/login-prompt.component';
import { RequiredDocumentationComponent } from '../components/required-documentation/required-documentation.component';
import { ForeignPairNoticeComponent } from '../components/foreign-pair-notice/foreign-pair-notice.component';
import { ActiveReservationNoticeComponent } from './active-reservation-notice/active-reservation-notice.component';
import { RewardCardComponent } from './reward-card/reward-card.component';
import { IncompleteProfileBannerComponent } from './incomplete-profile-banner/incomplete-profile-banner.component';
import { BranchSelectFieldComponent } from '../components/branch-select-field/branch-select-field.component';
import { BranchExchangeUsecase } from '../logic/branch/usecases/branch-exchange.usercase';
import { BranchRepository } from '../logic/branch/repository/branch.repository';
import { BranchImplementationRepository } from '../logic/branch/repository/branch-implementation.repository';

const branchExchangeUsecaseFactory = (branchRepo: BranchRepository) =>
  new BranchExchangeUsecase(branchRepo);
export const branchExchangeUsecaseProvider = {
  provide: BranchExchangeUsecase,
  useFactory: branchExchangeUsecaseFactory,
  deps: [BranchRepository],
};

feather.replace();

@NgModule({
  declarations: [
    FooterComponent,
    NavUserComponent,
    BackButtonComponent,
    ModalComponent,
    DivisaCardComponent,
    DivisaListComponent,
    ReservacionCardComponent,
    ReservacionTableComponent,
    ReservacionComponent,
    ReservacionCompleteComponent,
    ReservacionHistorialComponent,
    ReservacionVencidaComponent,
    HistoricoBranchComponent,
    SucursalCardComponent,
    PromocionModalComponent,
    PromotionDetailModalComponent,
    PromoBranchPanelComponent,
    SafeHtmlPipe,
    MxnCurrencyPipe,
    CentenarioUnitsPipe,
    CurrencyNamePipe,
    SucursalCardPromoComponent,
    QuoterComponent,
    PickupScheduleComponent,
    BranchSelectorComponent,
    ReservationConfirmationComponent,
    LoginPromptComponent,
    RequiredDocumentationComponent,
    ForeignPairNoticeComponent,
    ActiveReservationNoticeComponent,
    RewardCardComponent,
    IncompleteProfileBannerComponent,
    BranchSelectFieldComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    QRCodeModule,
    ScrollingModule,
    MatBottomSheetModule,
    MatDialogModule,
    NgxCurrencyDirective,
    MatMenuModule,
    TranslateModule,
  ],
  exports: [
    FooterComponent,
    NavUserComponent,
    BackButtonComponent,
    ModalComponent,
    DivisaCardComponent,
    DivisaListComponent,
    ReservacionCardComponent,
    ReservacionTableComponent,
    ReservacionComponent,
    ReservacionCompleteComponent,
    ReservacionHistorialComponent,
    ReservacionVencidaComponent,
    HistoricoBranchComponent,
    SucursalCardComponent,
    SafeHtmlPipe,
    MxnCurrencyPipe,
    CentenarioUnitsPipe,
    CurrencyNamePipe,
    QuoterComponent,
    PickupScheduleComponent,
    BranchSelectorComponent,
    ReservationConfirmationComponent,
    LoginPromptComponent,
    RequiredDocumentationComponent,
    ForeignPairNoticeComponent,
    ActiveReservationNoticeComponent,
    RewardCardComponent,
    IncompleteProfileBannerComponent,
    BranchSelectFieldComponent,
    MatTooltipModule,
    TranslateModule,
  ],
  providers: [
    branchExchangeUsecaseProvider,
    { provide: BranchRepository, useClass: BranchImplementationRepository },
  ],
})
export class SharedModule {}
